import { isDailyRent } from './checkOfferType';
import { ELeaseTermType, IOffer } from 'shared/types/offers';

export const getLeasePeriod = (offer: IOffer): string | null => {
  const { leaseTermType } = offer.bargainTerms || {};
  const { category } = offer;

  if (category && isDailyRent(category)) {
    return 'посуточно';
  }

  switch (leaseTermType) {
    case ELeaseTermType.LongTerm:
      return 'от года';
    case ELeaseTermType.FewMonths:
      return 'на несколько месяцев';
    default:
      return null;
  }
};
